import { useState, useEffect } from 'react';
import CardsOrganizational from '../components/CardsOrganizational'
import CardsAssistant from '../components/CardsAssistant'
import { Row, Col } from "react-bootstrap";
import Charts from '../components/Charts';
import RiskAnalysisTable from '../components/RiskAnalysisTable';
import DatePicker from "../components/DatePicker";
import BaseTablesingle from "../components/BaseTablesingle";
import Icon from '../components/Icon';
import Radio from "../components/Radio";
import Sort from '../components/Sort';
import SimpleSkeleton from "../skeletons/SimpleSkeleton";
import CardSkeleton from "../skeletons/CardSkeleton";
import BaseTable from "../components/BaseTable";
import { Tabs, Tab } from "react-bootstrap";
import { useMicrosoftAuth } from "../context/MicrosoftAuthContext";
import MetricsConsideredModal from '../components/MetricsConsideredModal';
import OrganizationalMetricsModal from '../components/OrganizationalMetricsModal';
import { useOrganizationalMetricsModal } from '../hooks/useOrganizationalMetricsModal';

import { fetchData, fetchDataPost, checkAccessToken } from "../services/apiService";
import { getPopupTableColumnName } from '../utils/commonUtils';
// import { FaCircle, FaHome } from "react-icons/fa"; // Using react-icons for icons

const Assistants = ({ isOpen, toggle }) => {
    const { userTeamData } = useMicrosoftAuth();
    const startOfMonth = new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1));
    const endOfMonth = new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0));
    const defaultStartDate = startOfMonth;
    const defaultEndDate = endOfMonth;

    const [dateRange, setDateRange] = useState([defaultStartDate, defaultEndDate]);
    const [startDate, endDate] = dateRange;

    const [allAssistantsData, setAllAssistantsData] = useState([]);
    const [allAssistantsDataLoading, setAllAssistantsDataLoading] = useState(false);

    const [objectives, setObjectives] = useState([]);
    const [objectivesCountLoading, setObjectivesCountLoading] = useState(true);

    const [greenMeticsCount, setGreenMeticsCount] = useState(0);
    const [yellowMeticsCount, setYellowMeticsCount] = useState(0);
    const [redMeticsCount, setRedMeticsCount] = useState(0);
    const [dateRangeData, setDateRangeData] = useState([]);
    const [metricsDateRangeData, setMetricsDateRangeData] = useState([]);
    const [metricBranchDataRangeData, setMetricBranchDataRangeData] = useState([]);
    const [metricManagersDataRangeData, setMetricManagersDataRangeData] = useState([]);
    const [metricAssistantsDataRangeData, setMetricAssistantsDataRangeData] = useState([]);
    const [metricPodsDataRangeData, setMetricPodsDataRangeData] = useState([]);

    const [organizationalEvaluationLoading, setOrganizationalEvaluationLoading] = useState(false);
    const [organizationalEvaluation, setOrganizationalEvaluation] = useState([]);

    const [metrics, setMetrics] = useState([]);
    const [activeObjectiveTab, setActiveObjectiveTab] = useState(0);
    const [activeObjectiveName, setActiveObjectiveName] = useState('');
    const [frequency, setFrequency] = useState('weekly');

    const organizationHeaders = ["Metric", "Baseline", "Target", "Result",  "Risk Level"];


    const [sortConfig, setSortConfig] = useState("name_asc");
    const [sortedData, setSortedData] = useState([]);

    const [showMetricsModal, setShowMetricsModal] = useState(false);
    const { modalState: orgMetricsModalState, handleMetricsCardClick: handleOrgMetricsCardClick, closeModal: closeOrgMetricsModal } = useOrganizationalMetricsModal();

    const [activeMetric, setActiveMetric] = useState({});

    const sortOptions = [
        { value: 'name_asc', label: 'Name (A→Z)' },
        { value: 'name_desc', label: 'Name (Z→A)' },
    ];

    const handleDateRangeChange = (newDateRange) => {
        // Create dates in UTC using Date.UTC()
        const startOfMonth = new Date(Date.UTC(newDateRange.startYear, newDateRange.startMonth - 1, 1));
        const endOfMonth = new Date(Date.UTC(newDateRange.endYear, newDateRange.endMonth, 0));
    
        // The rest of your function remains the same
        newDateRange = [startOfMonth, endOfMonth];
        setDateRange(newDateRange);
        const [startDate, endDate] = newDateRange;

        if (startDate && endDate) {
            getOrganizationalEvaluation(activeObjectiveTab, startDate, endDate, frequency);
        }
    };

    const handleMetricsCardClick = () => setShowMetricsModal(true);

    const handleOrganizationalMetricsCardClick = (cardType) => {
        handleOrgMetricsCardClick(cardType, {
            date: startDate || new Date(),
            title: activeObjectiveName
        });
    };

    async function getObjectives() {
        try {
            const result = await fetchData('getObjectives', controllerRef);

            const [startDate, endDate] = dateRange;
            if (result != null) {
                setObjectives(result);
                if (result.length > 0) {
                    setActiveObjectiveTab(result[0].id);
                    const activeObjective = result.find(objective => objective.id === result[0].id);
                    setActiveObjectiveName(activeObjective ? activeObjective.name : '');
                    getOrganizationalEvaluation(result[0].id, startDate, endDate, frequency);
                }
            }
        } catch (err) {
            console.log(err.message);
        } finally {
            setObjectivesCountLoading(true);
        }
    }
    
    async function getOrganizationalEvaluation(activeObjectiveTab, startDate, endDate, frequency = 'weekly') {
        setOrganizationalEvaluationLoading(true);
        try {
            var post_data = {};
            if (startDate) { 
                post_data.startDate = startDate;
            }
            if (endDate) {
                var endDateWithAdjustedTime = new Date(endDate);
                endDateWithAdjustedTime.setUTCHours(23, 59, 59, 999);
                post_data.endDate = endDateWithAdjustedTime;
            }
            post_data.objectiveID = activeObjectiveTab;
            post_data.frequency = frequency;
            if(userTeamData?.user_role_id.includes("10")){
                post_data.organization = "assistants";
            }else{
                post_data.organization = "myassistants";
            }
            post_data.user_team_id = userTeamData?.id;
            post_data.user_role_id = userTeamData?.user_role_id;
            var user_group = [];
            userTeamData?.user_group?.forEach(group => {
                user_group.push(group);
            });
            post_data.user_group = user_group;
            const result = await fetchDataPost('getOrganizationalEvaluation', post_data, controllerRef);
            console.log(result);
            if (result != null) {
                setMetrics(result.showMetrics);
                if(result.showMetrics.length>0){
                   setActiveMetric(result.showMetrics[0]);
                }
                setGreenMeticsCount(result.summary.greenMeticsCount??0);
                setYellowMeticsCount(result.summary.yellowMeticsCount??0);
                setRedMeticsCount(result.summary.redMeticsCount??0);
                setDateRangeData(result.dateRangeData);
                setMetricsDateRangeData(result.singleMetricsData);
                setMetricBranchDataRangeData(result.singleMetricBranchData);
                setMetricManagersDataRangeData(result.singleMetricManagersData || []);
                setMetricAssistantsDataRangeData(result.singleMetricAssistantData || []);
                setMetricPodsDataRangeData(result.singleMetricPodsData || []);
                
            }
            setOrganizationalEvaluationLoading(false);
        } catch (err) {
            console.log("err.message", err.message);
            // Don't set loading to false if request was cancelled
            if (err.name === 'AbortError' || err.message === 'canceled') {
                console.log('Request was cancelled');
                // Don't update loading state for cancelled requests
            } else {
                // Keep loading state as true for other errors
                console.log('Request failed with error');
                setOrganizationalEvaluationLoading(true);
            }
        } 
    }

    async function getAssistantsWithUsersCount() {
        setAllAssistantsDataLoading(true);
        try {
            var post_data = {};
            post_data.user_team_id = userTeamData?.id;
            post_data.user_role_id = userTeamData?.user_role_id;
            if(!userTeamData?.user_role_id.includes("10")){
                var user_group = [];
                userTeamData?.user_group?.forEach(group => {
                    user_group.push(group);
                });
                post_data.user_group = user_group;
            }
            const result = await fetchDataPost('getAssistantsWithManagers', post_data, controllerRef);
            if (result != null) {
                setAllAssistantsData(result);
            }
        } catch (err) {
            console.log(err.message);
        } finally {
            setAllAssistantsDataLoading(false);
        }
    }

    // Handle sort change from Sort component
    const handleSort = (field) => {
        setSortConfig(field);
    };
    
    // Sort and filter data when sort configuration, data, or search term changes
    useEffect(() => {
        if (allAssistantsData.length === 0) return;

        const sortableData = [...allAssistantsData];
        
        // Use all data without filtering
        const filteredData = sortableData;
        
        // Sort the filtered data
        filteredData.sort((a, b) => {
            const [field, direction] = sortConfig.split('_');
            // Handle numeric and string sorting differently
            if (typeof a[field] === 'number') {
                return direction === 'asc' 
                    ? a[field] - b[field]
                    : b[field] - a[field];
            } else {
                // String comparison for text fields
                const valueA = String(a[field]).toLowerCase();
                const valueB = String(b[field]).toLowerCase();
                
                if (direction === 'asc') {
                    return valueA.localeCompare(valueB);
                } else {
                    return valueB.localeCompare(valueA);
                }
            }
        });
        
        setSortedData(filteredData);
    }, [sortConfig, allAssistantsData]);
    
    var controllerRef = new AbortController();
    const loadData = async () => {
        await checkAccessToken(controllerRef);
        getAssistantsWithUsersCount();
        getObjectives();
    }

    useEffect(() => {
        loadData();
    }, []);
    return (
        <div className='bg-white p-30-19'>
           

            <div className='p-24 rounded-16 app-shadow-sm bg-white mb-24'>
                <div className='d-flex align-items-center justify-content-between'>
                    <div className='fw-600 text-24 text-black '>All Assistants</div>
                    
                </div>
                <Row>
                    {!allAssistantsDataLoading ?
                        sortedData.map((item, index) => (
                            <Col key={index} sm={12} md={6} lg={4} xl={3} className='mt-24'>
                                <CardsAssistant
                                    CardColor="bg-brand-light"
                                    CardLabel={item.name}
                                    phone={item.phone}
                                    email={item.email}
                                    PageRoute={"/assistants/singleassistant/" + item.userID}
                                />
                            </Col>
                        ))
                        :
                        <CardSkeleton rows={4} columns={4} />
                    }
                </Row>
            </div>

            <div className='organizational-analytics-container mb-24'>
                <div className='organizational-analytics-title'>All Assistants Analytics</div>

                <div className='analytics-controls-container'>
                    <div className='analytics-section'>
                        <div className='objective-controls'>
                            <div className='objective-label'>Select Objective:</div>
                            {objectives.map((item) => (
                                <button
                                    key={`${item.id}`}
                                    className={`objective-tab ${activeObjectiveTab == item.id ? 'active' : ''}`}
                                    onClick={() => {
                                        const [startDate, endDate] = dateRange;
                                        setActiveObjectiveTab(item.id);
                                        const obj = objectives.find(objective => objective.id == item.id);
                                        setActiveObjectiveName(obj ? obj.name : 'NA');
                                        getOrganizationalEvaluation(item.id, startDate, endDate, frequency);
                                    }}
                                >
                                    {item.name}
                                </button>
                            ))}
                        </div>

                        <div className='date-range-controls'>
                            <div className='date-picker-container'>
                                <DatePicker views={['year', 'month']} openTo="month" datetitle={'text-12 fw-500 text-4E4E4E'} datepicker={"bg-black text-white"} icon={"calendar-dark"} startDate={startDate} endDate={endDate} handleDateRangeChange={handleDateRangeChange} />
                            </div>
                        </div>
                    </div>

                    <div className='metrics-cards-container'>
                        <CardsOrganizational
                            isMetricsCard={true}
                            totalCount={metrics.length}
                            CardLabel="Metrics Considered"
                            onMetricsCardClick={handleMetricsCardClick}
                            isLoading={organizationalEvaluationLoading}
                        />
                        <CardsOrganizational
                            isMetricsCard={true}
                            metricsCardType="green"
                            totalCount={greenMeticsCount}
                            CardLabel="Green Level"
                            onDetailsClick={handleOrganizationalMetricsCardClick}
                            isLoading={organizationalEvaluationLoading}
                        />
                        <CardsOrganizational
                            isMetricsCard={true}
                            metricsCardType="amber"
                            totalCount={yellowMeticsCount}
                            CardLabel="Amber Level"
                            onDetailsClick={handleOrganizationalMetricsCardClick}
                            isLoading={organizationalEvaluationLoading}
                        />
                        <CardsOrganizational
                            isMetricsCard={true}
                            metricsCardType="red"
                            totalCount={redMeticsCount}
                            CardLabel="Red Level"
                            onDetailsClick={handleOrganizationalMetricsCardClick}
                            isLoading={organizationalEvaluationLoading}
                        />
                    </div>
                </div>
            </div>

            <div className='risk-analysis-group'>
                <Charts
                    objectiveName={activeObjectiveName}
                    allMetric={metrics}
                    metricsCount={metrics.length}
                    objectivesCount={objectives.length}
                    greenMeticsCount={greenMeticsCount}
                    yellowMeticsCount={yellowMeticsCount}
                    redMeticsCount={redMeticsCount}
                    dateRangeData={dateRangeData}
                    isDataLoading={organizationalEvaluationLoading}
                    activeMetric={activeMetric}
                    dateRange={dateRange}
                    onMetricChange={(metric) => setActiveMetric(metric)}
                    onDataChange={(data) => setActiveMetric(
                        (Array.isArray(data) ? data : []).map(item => ({
                            date: item.date,
                            target: item.target,
                            result: item.result,
                            riskLevel: item.risk
                        }))
                    )}
                    onFrequencyChange={(newFrequency) => {
                        setFrequency(newFrequency);
                        const [startDate, endDate] = dateRange;
                        getOrganizationalEvaluation(activeObjectiveTab, startDate, endDate, newFrequency);
                    }}
                />

                <RiskAnalysisTable
                    isDataLoading={organizationalEvaluationLoading}
                    dateRangeData={dateRangeData}
                    activeMetric={activeMetric}
                    metricBranchDataRangeData={metricAssistantsDataRangeData}
                    dateRange={dateRange}
                    date={startDate && endDate ?
                        `${startDate.getMonth() + 1}/${startDate.getFullYear()} → ${endDate.getMonth() + 1}/${endDate.getFullYear()}` :
                        ''
                    }
                    columnName={getPopupTableColumnName('assistants')}
                />
            </div>

            {/* Metrics Considered Modal */}
            <MetricsConsideredModal
                show={showMetricsModal}
                onHide={() => setShowMetricsModal(false)}
                objective={activeObjectiveName}
                metricsDateRangeData={metricsDateRangeData}
                isDataLoading={organizationalEvaluationLoading}
                date={startDate && endDate ?
                    `${startDate.getMonth() + 1}/${startDate.getFullYear()} → ${endDate.getMonth() + 1}/${endDate.getFullYear()}` :
                    ''
                }
            />

            {/* Organizational Metrics Modal */}
            <OrganizationalMetricsModal
                show={orgMetricsModalState.show}
                onHide={closeOrgMetricsModal}
                data={metricsDateRangeData}
                title={orgMetricsModalState.title}
                cardType={orgMetricsModalState.cardType}
                date={startDate && endDate ?
                    `${startDate.getMonth() + 1}/${startDate.getFullYear()} → ${endDate.getMonth() + 1}/${endDate.getFullYear()}` :
                    ''
                }
            />
        </div>
    );
};

export default Assistants;
